import { axiosInstance, API_PREFIX, type ApiResponse, type RequestParams } from '@/shared/api';
import type { ApiResponseList } from '@/shared/api/types';
import type { StaffBase, StaffCreatePayload, StaffUpdatePayload, StaffResetPasswordPayload } from '../model/types';

const BASE = `${API_PREFIX.ADMIN_V1}/staff`;

export const staffApi = {
  getList: async (params?: RequestParams): Promise<ApiResponseList<StaffBase>> => {
    const { data } = await axiosInstance.get<ApiResponseList<StaffBase>>(`${BASE}/index`, { params });
    return data;
  },

  getById: async (id: number): Promise<ApiResponse<StaffBase>> => {
    const { data } = await axiosInstance.get<ApiResponse<StaffBase>>(`${BASE}/show`, { params: { id } });
    return data;
  },

  create: async (payload: StaffCreatePayload): Promise<ApiResponse<StaffBase>> => {
    const { data } = await axiosInstance.post<ApiResponse<StaffBase>>(`${BASE}/create`, payload);
    return data;
  },

  update: async (payload: StaffUpdatePayload): Promise<ApiResponse<StaffBase>> => {
    const { data } = await axiosInstance.post<ApiResponse<StaffBase>>(`${BASE}/update`, payload);
    return data;
  },

  remove: async (id: number): Promise<ApiResponse<null>> => {
    const { data } = await axiosInstance.post<ApiResponse<null>>(`${BASE}/delete`, { id });
    return data;
  },

  resetPassword: async (payload: StaffResetPasswordPayload): Promise<ApiResponse<null>> => {
    const { data } = await axiosInstance.post<ApiResponse<null>>(`${BASE}/reset-password`, payload);
    return data;
  },
};
